import axios from "axios";
import { urlBaseHall } from './../../config/index';
import GroupModel from '../../../models/GroupModel';
import adminUserService from '../adminUser';

export default async function getGroupsApi(
  eventId = '',
) {
  try {
    let _token = await adminUserService.getHallTokenByEventId(eventId);

    const _options = {
      url: `${urlBaseHall}/hall/api/event/attribute/group/${eventId}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + _token,
      },
    };

    const _ret = await axios(_options);

    const _groups = [];
    if (_ret.data && _ret.data.success) {
      _ret.data.data.forEach(item => {
        const _group = GroupModel({
          id: item.id.toString(),
          value: item.id.toString(),
          text: item.nameGroup,
          eventId: eventId,
        });
        _groups.push(_group);
      });
    }
    return _groups;

  } catch (error) {
    console.log('Error getGroupsApi', error);
    throw error;
  }
}
